define('app/collections/posicoes',['require','backbone','rb'],function(require) {
    var Backbone = require('backbone');
    var R = require('rb');
    
    var Posicoes = Backbone.Collection.extend({});
    var posicoes = new Posicoes();

    R.getAll("SELECT posicao.id, posicao.titulo FROM posicao \
    	INNER JOIN produtoposicao ON produtoposicao.deleted=0 and produtoposicao.posicao_id = posicao.id \
    	INNER JOIN produto ON produto.deleted=0 and produto.ativo=1 and produto.id = produtoposicao.produto_id \
    	WHERE \
    		posicao.deleted=0 \
    		and posicao.ativo=1 \
    	GROUP BY posicao.id \
    	ORDER BY posicao.ordenamento DESC \
    ",[]).done(function(err,rows){
    	if (err) {
    		return console.log(err);
    	}
		posicoes.set(rows.map(function(row){
			row.checked = false;
			row.id = row.id|0;
			return row;
		}));
    	
    });
    
    return posicoes;
});
